import { O2OCommonContainer } from '../../../common/container/O2OContainer';
import { IState } from '../../../redux/reducer';
import TabPermission from './tab';

function mapStateToProps(rootState: IState) {
  return {};
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export const SuperPermissionContainer = O2OCommonContainer(TabPermission, mapStateToProps, mapDispatchToProps);
